import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiPath } from 'constants/api';
import { INTERNAL_SERVER_ERROR } from 'constants/common';

import type { ApiClient } from '@travel/api-client';
import { noticeError } from '@travel/tracker';
export const reportReviewById = createAsyncThunk<
  string,
  string,
  { extra: { apiClient: ApiClient } }
>('review/report', async (reviewId, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const path = apiPath.reviewReport.pathname(reviewId);

    await apiClient.post(path, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return reviewId;
  } catch (error) {
    noticeError('Report Review Failed', error);

    return rejectWithValue({
      message: error?.message || 'Failed to report review',
      code: error?.code || INTERNAL_SERVER_ERROR,
    });
  }
});
